import React from 'react';
import Navbar from './Navbar';
import ContactUs from './ContactUs';

function Terms() {
  return (
    <div>
      <Navbar />
      <div style={{ padding: '2rem', maxWidth: '900px', margin: '0 auto' }}>
        <h1 style={{
          textAlign: 'center',
          fontSize: '2.5rem',
          fontWeight: 'bold',
          color: 'black',
          marginBottom: '2rem'
        }}>
          Terms & Conditions
        </h1>

        <div style={{
          backgroundColor: 'white',
          padding: '2rem',
          borderRadius: '10px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          color: '#1E4CA4', // Medium blue
          fontSize: '1rem',
          lineHeight: '1.8',
          whiteSpace: 'pre-wrap',
        }}>
          <p>
            Thank you for accessing/shopping at www.vilvattamscb.com This site is owned by Vilvattam Service Co-Opertive Bank LTD No.337 (hereinafter referred to as www.vilvattamscb.com). 
            By accessing, shopping on this site, you indicate your unconditional acceptance of these terms & conditions. We reserve this right, in our sole discretion, to update or revise these terms & conditions. 
            Continued use of the site following the posting of any changes to the ‘terms & conditions’ constitutes your acceptance of those changes. At www.vilvattamscb.com, we try our best to create a space where 
            you can explore and shop for all your favorite things in a safe and secure environment.

            {"\n\n"}All products and information displayed on www.vilvattamscb.com constitutes an invitation to offer. www.vilvattamscb.com reserves the right to accept or reject your offer. 
            Your order for purchase constitutes your offer which shall be subject to the terms and conditions as listed below.

            {"\n\n"}<strong>Eligibility to use our site</strong>
            {"\n"}Use of the Site is available only to persons who can legally enter into contracts under applicable laws. 
            Persons who are incompetent to contract, within the meaning of the Indian Contract Act, 1872 including un-discharged insolvents etc. are not eligible to use the Site. 
            www.vilvattamscb.com reserves the right to terminate your access to the Site if it discovers that you are under the age of 18 years or suffer from any other disability, 
            as recognized under Indian Contract Act, 1872.

            {"\n\n"}<strong>Membership</strong>
            {"\n"}Although it's not essential to have an account to shop with www.vilvattamscb.com, you can shop as a guest. As a member, you agree to provide true, accurate, current, 
            and complete information about yourself as prompted by the site's registration form. Registration where prohibited under any law shall be void. 
            www.vilvattamscb.com reserves the right to revoke or terminate your registration for any reason at any time, without notice.

            {"\n\n"}<strong>Electronic Communications</strong>
            {"\n"}When you use the site or send emails or other data, information or communicate to us, you agree and understand that you are communicating with us electronically and 
            give your consent to receive communications electronically from us periodically, when required.

            {"\n\n"}<strong>Reviews, Feedback, Submissions</strong>
            {"\n"}All reviews, comments, feedback, postcards, suggestions, ideas, and other submissions disclosed, submitted or offered to www.vilvattamscb.com directly or otherwise 
            in connection with your use of this Site (collectively referred to as "Comments") will remain www.vilvattamscb.com's property. Such disclosure, submission or offer of any 
            comments shall constitute an assignment to www.vilvattamscb.com of all worldwide rights, titles and interests in all copyrights and other intellectual properties in the 
            comments, thus, it exclusively owns all such rights, titles and interests and shall not be limited in any way in its use.

            {"\n\n"}www.vilvattamscb.com is under no obligation to:
            {"\n"}(1) maintain any Comments in confidence;
            {"\n"}(2) pay you any compensation for any Comments;
            {"\n"}(3) respond to any Comments.

            {"\n\n"}You agree that your submitted comments will not violate this policy or any rights of third parties, and will not be libelous, unlawful, threatening, abusive, obscene, 
            or include viruses or spam. www.vilvattamscb.com reserves the right (but not obligation) to monitor or remove any comment. You agree not to impersonate anyone or provide 
            false information and you are solely responsible for the content of any comments you submit.

            {"\n\n"}<strong>Accuracy of Content / Information of Products on the Website</strong>
            {"\n"}While www.vilvattamscb.com strives to provide accurate product and pricing information, typographical errors may occur. 
            In the event that a product is listed at an incorrect price or with incorrect information due to an error, www.vilvattamscb.com shall have the right, 
            at its sole discretion, to modify the price or information or to cancel the order, unless the product has already been dispatched.
          </p>
        </div>
      </div>
      <ContactUs/>
    </div>
  );
}

export default Terms;
